import { canViewMenu } from "../utils/permissions";

// Function to create sidebar data with shop-aware routes and role-based filtering
export const getSidebarData = (shopRoutes, user, t, isCanteen = false) => {
  const allMenus = [
    {
      label: t("sidebar.main"),
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: t("sidebar.main"),
      submenuItems: [
        {
          label: t("sidebar.dashboard"),
          icon: "layout-grid",
          submenu: false,
          showSubRoute: false,
          link: shopRoutes?.dashboard || "/:shopId/admin-dashboard",
        },
        {
          label: t("sidebar.companySettings"),
          icon: "user-edit",
          submenu: false,
          showSubRoute: false,
          link: shopRoutes?.generalsettings || "/:shopId/general-settings",
        },
      ],
    },
    {
      label: t("sidebar.employeesUsers"),
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: t("sidebar.users"),
      submenuItems: [
        {
          label: t("sidebar.employees"),
          link: shopRoutes?.users || "/:shopId/users",
          icon: "user-star",
          showSubRoute: false,
          submenu: false,
        },
      ],
    },
    {
      label: t("sidebar.thirdParties"),
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: t("sidebar.people"),
      submenuItems: [
        {
          label: t("sidebar.companies"),
          link: shopRoutes?.companies || "/:shopId/companies",
          icon: "building",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: t("sidebar.customerContracts"),
          link: shopRoutes?.customercontract || "/:shopId/customer-contract",
          icon: "file-pencil",
          showSubRoute: false,
          submenu: false,
        },
      ],
    },
    //NEW SECTION: Subscription Plans
    {
      label: t("sidebar.plans"),
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: t("sidebar.plans"),
      submenuItems: [
        {
          label: t("sidebar.plans"),
          link: shopRoutes?.licenses || "/:shopId/licenses",
          icon: "layers", // or "package", "credit-card", etc.
          showSubRoute: false,
          submenu: false,
        },
      ],
    },
    {
      label: t("sidebar.financeAccounting"),
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: t("sidebar.financeAccounts"),
      submenuItems: [
        {
          label: t("sidebar.income"),
          link: shopRoutes?.incomelist || "/:shopId/income",
          submenu: false,
          showSubRoute: false,
          icon: "file-pencil",
        },
      ],
    },
    {
      label: t("sidebar.settings"),
      submenuOpen: false,
      showSubRoute: false,
      submenuHdr: t("sidebar.help"),
      submenuItems: [
        {
          label: t("sidebar.logout"),
          link: "/signin",
          icon: "logout",
          showSubRoute: false,
        },
        {
          label: t("sidebar.documentation"),
          link: "#",
          icon: "file-text",
          showSubRoute: false,
        },
      ],
    },
  ];

  if (!user) {
    return allMenus;
  }

  const filteredMenus = allMenus
    .map((section) => {
      if (!section.submenuItems) return section;

      const filteredSubmenuItems = section.submenuItems
        .map((item) => {
          if (item.submenu && item.submenuItems) {
            return {
              ...item,
              submenuItems: item.submenuItems,
            };
          }
          return item;
        })
        .filter((item) => {
          if (item.label) {
            return canViewMenu(user, item.label);
          }
          return true;
        });

      return {
        ...section,
        submenuItems: filteredSubmenuItems,
      };
    })
    .filter((section) => {
      if (section.label === t("sidebar.canteen") && !isCanteen) {
        return false;
      }
      if (section.label && !canViewMenu(user, section.label)) {
        return false;
      }
      if (!section.submenuItems || section.submenuItems.length === 0) {
        return false;
      }
      return true;
    });

  return filteredMenus;
};

export const SidebarData = [];